import {
  getTaskStatistics,
  getTaskManagerList,
  getOneTask,
  addNewTast,
  getPrioritiesList,
  updateTask,
  getAllUsers,
  getCalendarTaskList,
  deleteComment,
  createComments,
  getComments,
  deleteAttachmentFiles,
  addAttachmentFiles,
  getAttachmentFiles,
} from '@/api/taskManager'

export default {
  FETCH_TASK_STATISTICS({ commit }) {
    return getTaskStatistics().then(response => {
      commit('SET_TASK_STATISTICS', response.data)
      return response.data
    })
  },
  FETCH_ALL_USERS_LIST({ commit }, query) {
    return getAllUsers(query).then(response => {
      commit('SET_USERS_LIST', response.data)
    })
  },
  ADD_NEW_TASK(_, data) {
    return addNewTast(data).then(response => response.data)
  },
  UPDATE_TASK(_, data) {
    return updateTask(data).then(response => response.data)
  },
  FETCH_PRIORITIES_LIST({ commit }) {
    return getPrioritiesList().then(response => {
      commit('SET_PRIORITIES_LIST', response.data)
      return response.data
    })
  },
  FETCH_ONE_TASK({ commit }, id) {
    return getOneTask(id).then(response => {
      commit('SET_ONE_TASK', response.data)
      return response.data
    })
  },
  FETCH_TASK_MANAGER_LIST({ commit }, data) {
    return getTaskManagerList(data)
      .then(response => {
        commit('SET_TASK_MANAGER_LIST', response.data)
        return response.data
      })
  },
  FETCH_CALENDAR_TASK_LIST({ commit }, params) {
    return getCalendarTaskList(params)
      .then(response => {
        commit('SET_CALENDAR_TASK_LIST', response.data)
        return response.data
      })
  },
  FETCH_COMMENTS({ commit }, params) {
    return getComments(params).then(res => {
      commit('SET_COMMENTS', res.data)
    })
  },
  POST_COMMENT(_, data) {
    return createComments(data)
  },
  DELETE_COMMENT(_, id) {
    return deleteComment(id)
  },
  GET_ATTACHMENT_FILES({ commit }, query) {
    return getAttachmentFiles(query).then(response => {
      commit('SET_ATTACHMENT_FILES', response.data)
    })
  },
  UPLOAD_ATTACHMENT_FILE(_, data) {
    return addAttachmentFiles(data)
  },
  DELETE_ATTACHMENT_FILE(_, id) {
    return deleteAttachmentFiles(id)
  },
}
